import React, { ReactNode } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
  useHorizontalNav?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, useHorizontalNav = true }) => {
  return (
    <div className='min-h-screen'>
      {useHorizontalNav ? (
        // Layout com Header Horizontal
        <>
          <Header />
          <main className='pt-16'>
            <div className='mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8 py-6'>
              {children}
            </div>
          </main>
        </>
      ) : (
        // Layout com Sidebar (original)
        <>
          <Sidebar />
          <div className='lg:pl-72 transition-all duration-300'> {/* Adjusted padding to match new sidebar width */}
            <Header />
            <main className='py-8'>
              <div className='mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8 space-y-6'>
                {children}
              </div>
            </main>
          </div>
        </>
      )}
    </div>
  );
};

export default Layout;
